import React, { useEffect, useState } from "react";

const CookieConsentManager = (props) => {
    const [consentGiven, setConsentGiven] = useState(null);

    const checkConsent = () => {

        if (window.Cookiebot && window.Cookiebot.hasResponse) {

            const consent = window.Cookiebot.consent.necessary;

            setConsentGiven(consent);

        } else {

            // fallback if Cookiebot hasn't loaded yet
            const cookie = document.cookie
                .split("; ")
                .find(row => row.startsWith("CookieConsent="));

            if (cookie) {
                const decoded = decodeURIComponent(cookie.split("=")[1]);

                if (decoded.includes("preferences:true") ||
                    decoded.includes("statistics:true") ||
                    decoded.includes("marketing:true")) {

                    setConsentGiven(true);

                } else {
                    setConsentGiven(false);
                }
            }
        }
    };

    useEffect(() => {

        checkConsent();

        window.addEventListener("CookiebotOnAccept", checkConsent);
        window.addEventListener("CookiebotOnDecline", checkConsent);

        return () => {
            window.removeEventListener("CookiebotOnAccept", checkConsent);
            window.removeEventListener("CookiebotOnDecline", checkConsent);
        };
    }, []);

    return props.children(consentGiven);
};

export default CookieConsentManager;
